import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { Navigator } from "../../../components/menu/navigator";
import { LogoutService } from 'src/app/services/logout/logout.service';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-change-authenticator-option',
  templateUrl: './change-authenticator-option.component.html',
  styleUrls: ['./change-authenticator-option.component.scss'],
})
export class ChangeAuthenticatorOptionComponent  implements OnInit {

  @ViewChild(IonContent, {static: false}) content: IonContent;
  
  error = null;
  public authenticatorOptionForm: FormGroup;
  public authOption: AbstractControl;
  public authOptionGroup;
  public canSave: boolean = false;
  public currentUserSelection;
  constructor(
    public successMessageService: SuccessMessageService,
    private navigator: Navigator,
    private userSessionService: UserSessionService,
    private appLinks: AppLinksService,
    private config:ConfigService
  ) { }

  ngOnInit() {
    this.successMessageService.clearMessage();
  }

  ionViewDidEnter() {
    this.onGetUserCurrentChoice();
  }

  onGetUserCurrentChoice(){
    this.userSessionService.getCustomer().subscribe((customer: CustomerModel) => {
      if (customer) {
        if (null !== customer.getCustomDataProperty("MFA_METHOD")) {
          this.authOptionGroup = customer.getCustomDataProperty("MFA_METHOD");
          this.currentUserSelection = customer.getCustomDataProperty("MFA_METHOD");
          console.log(this.authOptionGroup)
        }else {
          this.authOptionGroup = this.config.getConfig().FEATURE_MFA_TYPE ?? 'SMS'
          this.currentUserSelection = this.config.getConfig().FEATURE_MFA_TYPE ?? 'SMS';
        }
      }
    });
  }

  onSelectOption(data){
    this.authOptionGroup = data;
    if(this.currentUserSelection){
      this.currentUserSelection == this.authOptionGroup ? this.canSave = false : this.canSave = true;
    } else {
      this.canSave = true;
    }
    
  }

  doNext(){
    if(this.authOptionGroup === 'SMS'){
      this.navigator.navigateTo('VerifyAuthappComponent', { multipleModals: true }, { isUpdate2FA: true });
    } else {
      this.navigator.navigateTo('VerifySmsComponent', { multipleModals: true }, { isUpdate2FA: true });
    }
  }

  closeModal = () => {
    this.navigator.dismiss();
  }

  //Putting Simple Link until we gets the proper scope. Need to move to config or WordPress page
  goToExternalLink(link) {
      this.appLinks.openMatchedExternalLinksPopover(link)
      return false;
  }

}
